import { TabProps } from 'primevue/tab';
import { TabListProps } from 'primevue/tablist';
import { TabPanelsProps } from 'primevue/tabpanels';

type PrimeVueTabsVariant = {
  tabList: Pick<TabListProps, 'pt' | 'dt'>;
  tab: Pick<TabProps, 'pt' | 'dt'>;
  tabPanels: Pick<TabPanelsProps, 'pt' | 'dt'>;
};

export const compactTabsVariant: PrimeVueTabsVariant = {
  tabList: {
    pt: {
      content: {
        style: {
          gap: '0.25rem',
        },
      },
      tabList: {
        style: {
          gap: '0.25rem',
        },
      },
      activeBar: {
        style: {
          height: '2px',
        },
      },
    },
  },
  tab: {
    pt: {
      root: ({ context }) => ({
        style: {
          padding: '0.375rem 0.75rem',
          'min-height': '2rem',
          'font-size': '0.875rem',
          'line-height': '1.25rem',
          ...(context.active ? { 'font-weight': '600' } : {}),
        },
      }),
    },
  },
  tabPanels: {
    pt: {
      root: {
        style: {
          padding: '0.75rem 0 0',
        },
      },
    },
  },
};
